<template>
  <div class="totals">
    <div class="totals_block" v-for="(guest, index) in guests" :key="guest.id">
      <div class="totals_guest">
        <ul class="totals_list">
          <li class="totals_list-item">
            <span class="totals_list-item-text">Заезд:</span>
            <span class="totals_list-item-value">{{dateIn}}, {{timeIn}}</span>
          </li>
          <li class="totals_list-item">
            <span class="totals_list-item-text">Выезд:</span>
            <span class="totals_list-item-value">{{dateOut}}, {{timeOut}}</span>
          </li>
          <li class="totals_list-item">
            <span class="totals_list-item-text">Гость:</span>
            <span class="totals_list-item-value">{{guest.fullName}}</span>
          </li>
          <li class="totals_list-item">
            <span class="totals_list-item-text">Тип гостя:</span>
            <span class="totals_list-item-value">{{guest.guestType.title}}</span>
          </li>
          <li class="totals_list-item">
            <span class="totals_list-item-text">Тип питания:</span>
            <span class="totals_list-item-value">{{guest.nutrition}}</span>
          </li>
          <li class="totals_list-item">
            <span class="totals_list-item-text">Вид лечения:</span>
            <span class="totals_list-item-value">{{guest.cure}}</span>
          </li>
          <li class="totals_list-item" v-if="guest.healthcard">
            <span class="totals_list-item-value">Санаторно-курортная карта</span>
          </li>
        </ul>

        <a
          href="javascript:void(0)"
          class="totals_guest-delete"
          @click="openDelConfirmationDialog(guest.id)"
          v-if="index > 0"
        >
          <v-icon>$cross</v-icon>
        </a>

        <div class="totals_guest-total">
          <span class="totals_guest-total-text">Сумма за гостя:</span>
          <span class="totals_guest-total-value">{{dispPrice(guest.price)}}</span>
        </div>
      </div>
    </div>

    <div class="totals_block" v-if="extraServices.length > 0">
      <ul class="totals_list totals_extra-service-list">
        <li class="totals_list-item totals_extra-service-item"  v-for="service in extraServices" :key="service.id">
          <span class="totals_list-item-text totals_extra-service-name">{{service.title}}:</span>
          <template v-if="service.id === 1653">
            <span class="totals_list-item-value totals_extra-service-price">Сумма рассчитывается оператором</span>
          </template>
          <template v-else>
            <span class="totals_list-item-value totals_extra-service-price"> {{dispPrice(service.data.totalPrice)}}</span>
          </template>
        </li>
      </ul>
    </div>

    <v-dialog
      v-model="delConfirmationDialog"
      max-width="570"
      style="z-index:1002"
    >
      <ui-dialog
        @close="delConfirmationDialog = false"
        :noHeader="true"
      >
        <p class="text text--center">
          Вы уверены, что хотите удалить гостя?
        </p>

        <template v-slot:actions>
          <v-btn class="ui-btn ui-btn--grey ui-dialog_action" @click.prevent="closeDelConfirmationDialog">Нет</v-btn>
          <v-btn class="ui-btn ui-dialog_action" @click.prevent="confirmDeleting()">Да</v-btn>
        </template>
      </ui-dialog>
    </v-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'totals',

  data: () => ({
    guestToDeleteId: null,
    delConfirmationDialog: false,
  }),

  methods: {
    ...mapActions({
      removeGuest: 'guestsModule/removeGuest'
    }),

    deleteGuest(id) {
      this.removeGuest(id)
    },

    dispPrice(price) {
      return `${String(price).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')} р`
    },

    openDelConfirmationDialog(id) {
      this.guestToDeleteId = id
      this.delConfirmationDialog = true
    },

    closeDelConfirmationDialog() {
      this.guestToDeleteId = null
      this.delConfirmationDialog = false
    },

    confirmDeleting() {
      this.deleteGuest(this.guestToDeleteId)
      this.closeDelConfirmationDialog()
    }
  },

  computed: {
    ...mapState({
      // extraServices: state => state.guestsModule.extraServices,
      selectedCategoryId: store => store.selection.selectedCategoryId,
    }),

    ...mapGetters({
      getFilteredGuestsFields: 'guestsModule/getFilteredGuestsFields',
      getNutritionById: 'dictionaries/getNutritionById',
      getCureById: 'dictionaries/getCureById',
      getGuestTypeById: 'dictionaries/getGuestTypeById',
      extraServices: 'extraServices/getSelectedExtraServices',
      getRoomCategoryById: `dictionaries/getRoomCategoryById`,
    }),

    selectedCategoryData() {
      return this.getRoomCategoryById(this.selectedCategoryId)
    },

    activeCheckout() {
      return this.$store.state.selection?.checkoutTime
    },
    timeIn() {
      return this.activeCheckout?.timeIn
    },
    timeOut() {
      return this.activeCheckout.timeOut
    },

    guests() {
      return this.getFilteredGuestsFields([
        'id',
        'firstName',
        'secondName',
        'thirdName',
        'isNoThirdName',
        'guestType',
        'nutrition',
        'cure',
        'healthcard',
        'isPurchaser',
        'price',
      ]).reduce((acc, cur) => {
        let fullName =  `${cur.secondName} ${cur.firstName}`
        if(!cur.isNoThirdName) fullName += ` ${cur.thirdName}`

        // console.log(`cure ${cur.cure} divId ${this.selectedCategoryData.divisionId}`)
        // console.log(this.getCureById(cur.cure, this.selectedCategoryData.divisionId))

        let tempObj = {
          id: cur.id,
          fullName: fullName,
          guestType: this.getGuestTypeById(cur.guestType),
          nutrition: +cur.guestType !== 2 ? this.getNutritionById(cur.nutrition).title : `Нет`,
          cure: +cur.guestType !== 2 ? this.getCureById(cur.cure, this.selectedCategoryData.divisionId)?.title : `Нет`,
          healthcard: cur.healthcard,
          price: cur.price,
        }

        // if(cur.isPurchaser) {
        //   // если гость является плательщиком, приписываем ему все выбранные допы
        //   let extraServices = []
        //   this.extraServices.forEach(service => {
        //     if(service)
        //   });.parking.isSelected) {
        //     tempObj.parking = 'true'
        //   }
        // }

        acc.push(tempObj)
        return acc
      }, [])
    },
    dateIn() {
      const arrDateIn = this.$store.state.selection?.dateIn?.split('-')
      return `${arrDateIn[2]}.${arrDateIn[1]}.${arrDateIn[0]}`
    },
    dateOut() {
      const arrDateOut = this.$store.state.selection?.dateOut?.split('-')
      return `${arrDateOut[2]}.${arrDateOut[1]}.${arrDateOut[0]}`
    }
  },
}
</script>

<style lang="sass">
.totals_block
  + .totals_block
    margin-top: 40px
    padding-top: 40px
    border-top: 1px solid #8a8a8a

.totals_guest
  width: 100%
  display: flex
  justify-content: space-between
  align-items: flex-end
  position: relative

.v-application a.totals_guest-delete
  color: #C01717

.totals_guest-delete
  position: absolute
  top: 0
  right: 0
  text-decoration: none
  color: #C01717
  font-size: .5em

  .theme--light.v-icon
    color: inherit

  .v-icon.v-icon
    font-size: inherit

  .v-icon__component
    width: 1em
    height: auto

.totals_guest-total-text
  font-weight: 300

.totals_guest-total-value
  font-size: 1.125em
  font-weight: 700
  color: #1A4745
  margin-left: 10px

.totals_list
  list-style: none
  padding: 0
  margin: 0

.v-application ul.totals_list
    padding: 0

.totals_list-item
  width: 100%
  display: flex

  + .totals_list-item
    margin-top: 10px

.totals_list-item-value
  // width:

.totals_list-item-text
  font-weight: 300

  + .totals_list-item-value
    margin-left: 10px

.totals_extra-service-price
  font-weight: 700
  font-size: 1.125em

@media screen and (max-width: $mobile-breakpoint)
  .totals_block
    background-color: #CEE1E7
    border-radius: px-em(15, 12)
    padding: px-em(17,12) px-em(20,12) px-em(25,12)

    + .totals_block
      padding-top: px-em(17,12)
      margin-top: px-em(20,12)
      border-top: none

  .totals_guest
    flex-direction: column
    align-items: flex-start

  .totals_list-item
    flex-direction: column

  .totals_list-item-text + .totals_list-item-value
    margin-left: 0
    margin-top: px-em(5, 12)

  .totals_guest-total
    padding-top: px-em(20,12)
    margin-top: px-em(15,12)
    position: relative
    width: 100%
    display: flex
    align-items: baseline
    justify-content: space-between

    &::before
      content: ""
      display: block
      position: absolute
      top: 0
      left: 0
      right: 0
      height: px-em(1,12)
      background-color: #B1B1B1

  .totals_guest-total-value,
  .totals_extra-service-price
    font-size: px-em(16,12)

  .totals_guest-delete
    font-size: px-em(10,12)

  .totals_extra-service-item
    flex-direction: row
    align-items: baseline
    justify-content: space-between
</style>
